__turbopack_context__.v({
  "accordionBody": "AccordionSection-module-scss-module__BFWjCG__accordionBody",
  "accordionHeader": "AccordionSection-module-scss-module__BFWjCG__accordionHeader",
  "innerAccordionHeader": "AccordionSection-module-scss-module__BFWjCG__innerAccordionHeader",
  "labelWrapper": "AccordionSection-module-scss-module__BFWjCG__labelWrapper",
  "smallParagraph": "AccordionSection-module-scss-module__BFWjCG__smallParagraph",
  "wrapper": "AccordionSection-module-scss-module__BFWjCG__wrapper",
});
